export const buildTime = '2026-09-22 10:48:04 UTC';
